import PropTypes from "prop-types"
import React from "react"
import { Message } from "semantic-ui-react"
import * as css from "./Info.module.less"

function Info({ title, type, children }) {
  return (
    <Message as="span" {...{ [type]: true }} className={css.root}>
      {title && (
        <Message.Header as="span" className="block">
          {title}
        </Message.Header>
      )}
      {children}
    </Message>
  )
}

Info.defaultProps = {
  type: "info",
}

Info.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(["info", "error", "success", "warning"]),
  children: PropTypes.node,
}

export default Info
